<template>
  <div :class="{ 'is-child': depth != 0 }">
    <div
      :class="{ 'mx-0 mb-3': depth != 0 }"
      v-for="(item, index) in items"
      :key="`${depth}-${index}`"
    >
      <template
        v-if="
          (depth === 0 && isCurrentPage(item)) ||
          (depth > 0 && isActive(item) && isCurrentPage(item))
        "
      >
        <template v-if="item.ticket_field_id === 7">
          <div class="input-action admin">
            <InputText
              :textFloat="''"
              :value="item.displayValue"
              :placeholder="item.label_admin"
              type="text"
              :isRequired="Boolean(item.is_require_submit)"
              :v="errors.$each.$iter[index].value"
              :isValidate="errors.$each.$iter[index].value.$error"
              :textValidate="item.validate_text_admin || undefined"
              readonly
              custom-label
              @inputClick="handleAssignTo(index, item.value)"
            >
              <template #textFloat>
                <div class="custom-label">
                  <label>
                    {{ item.label_admin }}
                    <span
                      v-if="Boolean(item.is_require_submit)"
                      class="text-danger"
                      >*</span
                    >
                  </label>
                </div>
              </template>
            </InputText>

            <div class="input-action-icon">
              <font-awesome-icon
                icon="search"
                class="ml-2"
                @click="handleAssignTo(index, item.value)"
              />
            </div>
          </div>
        </template>
        <template v-else-if="item.ticket_field_id === 1">
          <div
            class="input-action"
            :class="[{ disabled: isCustomer || isEdit }]"
          >
            <InputText
              textFloat=""
              :value="item.displayValue"
              :placeholder="item.label_admin"
              type="text"
              :isRequired="Boolean(item.is_require_submit)"
              :v="errors.$each.$iter[index].value"
              :isValidate="errors.$each.$iter[index].value.$error"
              readonly
              disabled
              :textValidate="item.validate_text_admin || undefined"
              @inputClick="handleCustomer(index, item.value)"
              customLabel
            >
              <template #textFloat>
                <div class="custom-label">
                  <label>
                    {{ item.label_admin }}
                    <span
                      v-if="Boolean(item.is_require_submit)"
                      class="text-danger"
                      >*</span
                    >
                  </label>

                  <b-form-checkbox
                    v-if="!isEdit && pluginEmail == 1"
                    v-model="is_send_mail_customer"
                    :disabled="!isUserHasEmail"
                    class="pointer-event-all"
                    >Send Email To Customer
                  </b-form-checkbox>
                </div>
              </template>
            </InputText>
            <div class="input-action-icon">
              <font-awesome-icon
                icon="search"
                class="ml-2"
                @click="handleCustomer(index, item.value)"
              />
            </div>
          </div>
          <template v-if="is_send_mail_customer">
            <div class="mb-3">
              <label class="main-label">
                Sender Email<span class="text-danger ml-1">*</span>
              </label>

              <multiselect
                :close-on-select="true"
                :clear-on-select="false"
                v-model="senderId"
                :options="senderList"
                placeholder="Sender Email"
                track-by="id"
                label="email"
                :multiple="false"
                @close="handleOnBlur"
                @select="setSignature"
              >
                <template v-slot:noResult>
                  <span>No matching data found.</span>
                </template>
              </multiselect>
            </div>
          </template>
        </template>

        <template
          v-else-if="
            item.name === 'RelatedTicket' &&
            $store.state.permission.Permission.response.includes(33)
          "
        >
          <div class="my-4">
            <div class="d-flex justify-content-between align-items-end">
              <label :for="item.label_admin" class="mb-0"
                >{{ item.label_admin }}
                <span
                  v-if="Boolean(item.is_require_submit)"
                  class="text-danger ml-1"
                  >*</span
                >
              </label>

              <b-dropdown
                id="dropdown"
                right
                class="btn-mobile dropdown-template"
              >
                <template #button-content>
                  <div class="d-inline-flex mr-2">
                    <font-awesome-icon icon="plus" class="d-md-none" />
                    <span class="d-none d-md-block">
                      <font-awesome-icon icon="plus-square" class="pointer" />
                      <span class="btn-text ml-2">Add</span>
                    </span>
                  </div>
                </template>
                <b-dropdown-item @click="handleBooking(index, item.value)">
                  <b-button variant="mobile"> Booking </b-button>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div
              v-for="(booking, bindex) in item.value"
              @click="openBooking(booking, index)"
              class="d-flex align-items-center"
              :key="'booking-' + bindex"
            >
              <div class="booking-card">
                <div class="icon">
                  <font-awesome-icon icon="calendar-check" size="lg" />
                </div>
                <div class="detail">
                  <div>
                    <div class="prefix">Booking No: {{ booking.title }}</div>

                    <div class="name">{{ booking.sub_title }}</div>
                    <div class="time">
                      {{ booking.date | moment($formatDateNew) }}
                      {{ booking.date | moment("HH:mm:ss") }}
                    </div>
                  </div>
                  <div class="status">
                    Status:
                    <span :class="colorClass(booking)">{{
                      booking.status
                    }}</span>
                  </div>
                </div>
              </div>

              <font-awesome-icon
                icon="trash-alt"
                class="ml-3 text-danger cursor-pointer"
                @click.prevent.stop="deleteRelatedBooking(index, bindex)"
              />
            </div>
            <div v-if="item.value.length === 0" class="no-data-panel">
              <div>No item selected.</div>
            </div>
          </div>
        </template>
        <template
          v-else-if="item.name != 'RelatedTicket' && item.field_type_id === 1"
        >
          <InputText
            :textFloat="item.label_admin"
            v-model="item.value"
            :placeholder="item.label_admin"
            :type="
              item.field_condition.length &&
              item.field_condition[0].value === 'number'
                ? 'number'
                : 'text'
            "
            :isRequired="Boolean(item.is_require_submit)"
            :v="errors.$each.$iter[index].value"
            :isValidate="errors.$each.$iter[index].value.$error"
            :textValidate="item.validate_text_admin || undefined"
            :disabled="isEdit && [2, 3].includes(item.ticket_field_id)"
            :maxLength="
              item.field_condition[1]
                ? Number(item.field_condition[1].value || 255)
                : 255
            "
          />
        </template>
        <template v-else-if="item.field_type_id === 2">
          <label :for="item.label_admin"
            >{{ item.label_admin }}
            <span
              v-if="Boolean(item.is_require_submit)"
              class="text-danger ml-1"
              >*</span
            >
          </label>

          <b-form-checkbox-group
            :id="`${depth}-${item.label_admin}-${item.id}`"
            :name="`${depth}-${item.label_admin}-${item.id}`"
            v-model="item.value"
            :options="item.field_choice"
            value-field="id"
            text-field="name"
            class="ml-4 mb-3"
            stacked
            @change="selectedIndex = index"
          ></b-form-checkbox-group>
          <div v-if="errors.$each.$iter[index].value.$error">
            <span class="text-danger">{{
              item.validate_text_admin || "Please Select."
            }}</span>
          </div>
        </template>
        <template v-else-if="item.field_type_id === 3">
          <div class="mb-3">
            <label class="main-label">
              {{ item.label_admin
              }}<span
                v-if="Boolean(item.is_require_submit)"
                class="text-danger ml-1"
                >*</span
              ></label
            >

            <multiselect
              :close-on-select="item.field_type_id === 4 ? true : false"
              :clear-on-select="false"
              v-model="item.value"
              :options="item.field_choice"
              :placeholder="item.label_admin"
              track-by="id"
              label="name"
              :multiple="item.field_type_id === 4 ? false : true"
              :class="[errors.$each.$iter[index].value.$error ? 'error' : '']"
              @select="selectedIndex = index"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="null"
                  >-- Select {{ item.label_admin }} --</b-form-select-option
                >
              </template>
              <template v-slot:no-result>
                <span>No matching data found.</span>
              </template>
            </multiselect>
            <div v-if="errors.$each.$iter[index].value.$error">
              <span class="text-danger">{{
                item.validate_text_admin || "Please Select."
              }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="item.field_type_id === 4">
          <template v-if="item.ticket_field_id == 6">
            <div class="mb-3">
              <label class="main-label">
                {{ item.label_admin
                }}<span
                  v-if="Boolean(item.is_require_submit)"
                  class="text-danger ml-1"
                  >*</span
                ></label
              >

              <multiselect
                :close-on-select="item.field_type_id === 4 ? true : false"
                :clear-on-select="false"
                v-model="item.value"
                :options="item.field_choice"
                :placeholder="item.label_admin"
                track-by="id"
                label="name"
                :multiple="item.field_type_id === 4 ? false : true"
                :class="[errors.$each.$iter[index].value.$error ? 'error' : '']"
                @select="
                  (val) => {
                    selectedIndex = index;
                    handleOnChange(item, val);
                  }
                "
                :disabled="
                  (isEdit && [3, 2].includes(item.ticket_field_id)) ||
                  (isEdit &&
                    status == 4 &&
                    [5, 6].includes(item.ticket_field_id))
                "
              >
                <template v-slot:option-first>
                  <b-form-select-option :value="null"
                    >-- Select {{ item.label_admin }} --</b-form-select-option
                  >
                </template>
                <template v-slot:noResult>
                  <span>No matching data found.</span>
                </template>
              </multiselect>
              <div v-if="errors.$each.$iter[index].value.$error">
                <span class="text-danger">{{
                  item.validate_text_admin || "Please Select."
                }}</span>
              </div>
            </div>
          </template>
          <InputSelect
            v-else
            :title="item.label_admin"
            :name="item.label_admin"
            :isRequired="Boolean(item.is_require_submit)"
            v-model="item.value"
            v-bind:options="item.field_choice"
            valueField="id"
            textField="name"
            :v="errors.$each.$iter[index].value"
            :isValidate="errors.$each.$iter[index].value.$error"
            :textValidate="item.validate_text_admin || undefined"
            :disabled="
              (isEdit && [3, 2].includes(item.ticket_field_id)) ||
              (isEdit && status == 4 && [5, 6].includes(item.ticket_field_id))
            "
            @onDataChange="
              (val) => {
                selectedIndex = index;
                handleOnChange(item, val);
              }
            "
          >
            <template v-slot:option-first>
              <b-form-select-option :value="null"
                >-- Select {{ item.label_admin }} --</b-form-select-option
              >
            </template>
          </InputSelect>
        </template>

        <template v-else-if="item.field_type_id === 6">
          <InputSelect
            :title="item.label_admin"
            :name="item.label_admin"
            :isRequired="Boolean(item.is_require_submit)"
            v-model="item.value"
            v-bind:options="item.branch_list || []"
            valueField="id"
            textField="name"
            :v="errors.$each.$iter[index].value"
            :isValidate="errors.$each.$iter[index].value.$error"
            :textValidate="item.validate_text_admin || undefined"
            class="mt-3"
          >
            <template v-slot:option-first>
              <b-form-select-option :value="null"
                >-- Select {{ item.label_admin }} --</b-form-select-option
              >
            </template>
          </InputSelect>
        </template>
        <template v-else-if="item.field_type_id === 5">
          <b-row class="mb-3">
            <b-col>
              <label class="label"
                >{{ item.label_admin
                }}<span
                  v-if="Boolean(item.is_require_submit)"
                  class="text-danger ml-1"
                  >*</span
                ></label
              >
              <div
                :class="[
                  errors.$each.$iter[index].value.$error
                    ? 'border-error input-container'
                    : 'input-container',
                ]"
              >
                <datetime
                  type="date"
                  class="date-picker"
                  :input-style="styleDatetime"
                  v-model="item.value"
                  placeholder="DD/MM/YYYY"
                  format="dd/MM/yyyy"
                  value-zone="Asia/Bangkok"
                  :ref="`${item.id}-datetime`"
                >
                </datetime>
                <div
                  :class="'icon-primary text-right'"
                  @click="$refs[`${item.id}-datetime`][0].isOpen = true"
                >
                  <font-awesome-icon
                    icon="calendar-alt"
                    :class="'pointer color-primary'"
                    color="#B41BB4"
                  />
                </div>
              </div>
              <div v-if="errors.$each.$iter[index].value.$error">
                <span class="text-danger">{{
                  item.validate_text_admin || "Please Select."
                }}</span>
              </div>
            </b-col>
            <b-col class="mt-auto">
              <div
                :class="[
                  errors.$each.$iter[index].value.$error
                    ? 'border-error input-container'
                    : 'input-container',
                ]"
              >
                <datetime
                  type="time"
                  class="date-picker"
                  :input-style="styleDatetime"
                  v-model="item.value"
                  placeholder="HH:MM"
                  format="HH:mm"
                  value-zone="Asia/Bangkok"
                  :ref="`${item.id}-time`"
                >
                </datetime>
                <div
                  :class="'icon-primary text-right'"
                  @click="$refs[`${item.id}-time`][0].isOpen = true"
                >
                  <font-awesome-icon
                    icon="calendar-alt"
                    :class="'pointer color-primary'"
                    color="#B41BB4"
                  />
                </div>
              </div>
              <div v-if="errors.$each.$iter[index].value.$error">
                <span class="text-danger">{{
                  item.validate_text_admin || "Please Select."
                }}</span>
              </div>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="item.field_type_id === 7">
          <b-row>
            <b-col>
              <label class="label"
                >{{ item.label_admin
                }}<span
                  v-if="Boolean(item.is_require_submit)"
                  class="text-danger ml-1"
                  >*</span
                ></label
              >
              <div
                :class="[
                  errors.$each.$iter[index].value.$error
                    ? 'border-error input-container'
                    : 'input-container',
                ]"
              >
                <datetime
                  type="date"
                  class="date-picker"
                  :input-style="styleDatetime"
                  v-model="item.value"
                  placeholder="DD/MM/YYYY"
                  format="dd/MM/yyyy"
                  value-zone="Asia/Bangkok"
                  :ref="`${item.id}-date`"
                >
                </datetime>

                <div
                  :class="'icon-primary text-right'"
                  @click="$refs[`${item.id}-date`][0].isOpen = true"
                >
                  <font-awesome-icon
                    icon="calendar-alt"
                    :class="'pointer color-primary'"
                    color="#B41BB4"
                  />
                </div>
              </div>
              <div v-if="errors.$each.$iter[index].value.$error">
                <span class="text-danger">{{
                  item.validate_text_admin || "Please Select."
                }}</span>
              </div>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="item.field_type_id === 8">
          <UploadFile
            v-model="item.value"
            :value="item.value"
            :textFloat="item.label_admin"
            :placeholder="item.label_admin"
            format="image"
            name="thumbnail"
            accept="image/jpeg, image/png"
            text="*Please upload only file .png, .jpg size 1:1  and less than 10 MB"
            :isRequired="Boolean(item.is_require_submit)"
            v-on:onFileChange="($event) => onImageChange($event, index)"
            :fileName="item.value"
            :isValidate="errors.$each.$iter[index].value.$error"
            :v="errors.$each.$iter[index].value"
            :textValidate="item.validate_text_admin || undefined"
          />
          <div @click="showImage(item.value)" v-if="item.value">
            <PreviewBox
              v-on:delete="onDeleteImage(index)"
              :disabled="item.isLoading"
              :showPreviewType="0"
              :showPreview="item.value"
              :isLoadingImage="item.isLoading"
              :ratioType="1"
              class="mb-3"
            />
          </div>
        </template>

        <template v-else-if="item.field_type_id === 12">
          <TextEditorTiny
            :ref="`${depth}-editor`"
            v-if="!(item.ticket_field_id == 4 && isEdit)"
            :textFloat="item.label_admin"
            :rows="4"
            :value="item.value"
            :name="`${index}-${depth}-${item.name}`"
            placeholder="Type something..."
            :v="errors.$each.$iter[index].value"
            @onDataChange="(val) => (item.value = val)"
            :isRequired="Boolean(item.is_require_submit)"
            :isValidate="errors.$each.$iter[index].value.$error"
            :textValidate="item.validate_text_admin || undefined"
            :defaultEdit="isEdit"
            @addFileAttachment="addFileAttachment"
            :showTemplate="item.ticket_field_id == 4"
            F
            :addFile="is_send_mail_customer"
          >
          </TextEditorTiny>
        </template>

        <template v-else-if="item.field_type_id === 10">
          <div class="text-title my-3">{{ item.label_admin }}</div>
        </template>
        <template v-else-if="item.field_type_id === 11">
          <div class="text-sub-title my-3">{{ item.label_admin }}</div>
        </template>
        <template v-else-if="item.field_type_id === 13">
          <div class="my-3"></div>
        </template>

        <div
          v-if="item.field_dependent && item.field_dependent.length"
          class="mt-3"
        >
          <FormInputList
            :items="item.field_dependent"
            :depth="depth + 1"
            :parentValue="item.value"
            :errors="errors.$each.$iter[index].field_dependent"
            :currentPage="currentPage"
            class="mt-3"
            :isDeleted="isDeleted"
            :permissionDisable="permissionDisable"
          />
        </div>
      </template>
    </div>

    <ModalAdminList
      :ref="`${depth}-adminModal`"
      :selectedAdmin="selectedAdmin"
      @select="handleSelectedAdmin"
    />
    <ModalCustomerList
      :ref="`${depth}-customerModal`"
      @select="handleSelectedCustomer"
      :selectedCustomer="selectedCustomer"
    />
    <ModalTemplate :ref="`${depth}-modalTemplate`" />
    <ModalPreviewImage :ref="`${depth}-modalPreviewImage`" />
    <ModalBookingList
      :selectedBooking="selectedBooking"
      :ref="`${depth}-modalBooking`"
      @select="handleSelectedBooking"
      :isList="true"
      @addBooking="handleBookingForm"
    />

    <BookingFormSidebar
      :id="selectedBookingId"
      :templateId="bookingTemplateId"
      :customer="selectedCustomerData"
      :ref="`${depth}-modalBookingForm`"
      @addBooking="addBookingAfterCreate"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import Multiselect from "vue-multiselect";
import InputSelect from "@/components/inputs/InputSelect";

import ModalAdminList from "@/components/ticket/activity/ModalAdminList";
import ModalCustomerList from "@/components/ticket/activity/ModalCustomerList";
import TextEditorTiny from "@/components/inputs/TextEditorsTiny";
import UploadFile from "@/components/inputs/UploadFile";
import PreviewBox from "@/components/PreviewBox.vue";
import ModalPreviewImage from "@/components/modal/ModalPreviewImage";
import ModalTemplate from "@/components/ticket/activity/ModalTemplate";
import ModalBookingList from "@/components/ticket/activity/ModalBookingList";
import BookingFormSidebar from "@/components/ticket/activity/BookingFormSidebar";

export default {
  name: "FieldInputList",
  components: {
    InputText,
    InputSelect,
    BookingFormSidebar,
    Multiselect,
    ModalBookingList,
    ModalAdminList,
    ModalCustomerList,
    TextEditorTiny,
    UploadFile,
    PreviewBox,
    ModalTemplate,
    ModalPreviewImage,
    FormInputList: () => import("@/components/FormInputList.vue"),
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    depth: {
      required: true,
      type: Number,
    },
    errors: {
      required: true,
      type: Object,
    },
    parentValue: {
      required: false,
    },
    isEdit: {
      required: false,
      type: Boolean,
    },
    isCustomer: {
      required: false,
      type: Boolean,
    },
    status: {
      required: false,
      type: Number | null,
      default: null,
    },
    currentPage: {
      required: false,
      type: Number,
      default: 1,
    },
    rawAdmin: {
      required: false,
      type: String,
    },
    pluginEmail: {
      required: false,
      // type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      selectedIndex: 0,
      selectedBooking: [],
      selectedBookingId: 0,
      bookingTemplateId: 0,
      selectedAdmin: null,
      selectedCustomer: null,
      selectedCustomerData: null,
      isLoadingImage: false,
      isDisable: false,
      isAssignTome: false,
      is_send_mail_customer: false,
      adminData: {},
      isUserHasEmail: true,
      fileAttach: [],
      senderList: [],
      senderId: [],
      signatureList: [],
    };
  },
  watch: {
    parentValue: {
      handler(newVal) {
        if (this.depth > 0 && newVal) {
          this.items.forEach((element) => {
            element.isActive = this.isActive(element);
            if (element.field_dependent.length) {
              element.field_dependent.forEach((child) => {
                child.isActive = false;
              });
            }
          });
        }
      },
      immediate: true,
      deep: true,
    },
    is_send_mail_customer(val) {
      if (val) this.getSignatureEmail();
      if (!val) (this.fileAttach = []), this.clearFileAttachment();
    },
  },
  computed: {
    isShowAssignToMe() {
      if (!this.rawAdmin) return true;
      const currentAdminValue = this.getAdminValue();
      return currentAdminValue.value !== this.rawAdmin && this.rawAdmin;
    },
    signatureIndex() {
      return this.signatureList.find(
        (e) => e.ticket_email_plugin_id == this.senderId.id
      );
    },
  },

  created() {
    // this.getCurrentUser();
    this.getTicketConnection();
    if (this.dept == 0) this.totalPage = this.items[0].page;
    // const customer = this.items.find((item) => item.ticket_field_id === 1);
    // if (customer && customer.selectedValue) {
    //   this.selectedCustomerData = {
    //     ...customer.selectedValue,
    //   };
    // }
  },

  methods: {
    setSignature() {
      this.$refs[`${this.depth}-editor`]?.[0]?.updateModalValue(
        "<p></p><br/>" + this.signatureIndex?.description || ""
      );
    },
    async getSignatureEmail() {
      if (this.signatureList.length > 0) return;
      const res = await this.axios("/setting/Get/Email/Signature");

      this.signatureList = res.data.detail;
      this.setSignature();
    },
    addBookingAfterCreate(booking, id) {
      const targetIndex = this.items[this.selectedIndex].value.findIndex(
        (item) => item.ticket_relate_ref_id === id
      );
      if (targetIndex < 0) {
        this.items[this.selectedIndex].value.push({
          id: 0,
          ...booking,
        });
        this.$forceUpdate();
      } else {
        this.items[this.selectedIndex].value[targetIndex] = booking;
        this.$forceUpdate();
      }
    },
    deleteRelatedBooking(fieldIndex, bookingIndex) {
      this.items[fieldIndex].value.splice(bookingIndex, 1);
      this.$forceUpdate();
    },
    getAdminValue() {
      return this.items.find((el) => el.ticket_field_id === 7);
    },
    isCurrentPage(item) {
      return item.page && item.page == this.currentPage;
    },

    showImage(imageUrl) {
      this.$refs[`${this.depth}-modalPreviewImage`].show(imageUrl);
    },
    getCurrentUser: async function () {
      const { data } = await this.axios.get(`/ticket/adminuserguid`);
      if (data.result == 1) {
        this.adminData = await this.$refs[
          `${this.depth}-adminModal`
        ].filterByGuid(data.detail);
      }
    },
    async onAssignToMeChange(value, index) {
      this.selectedIndex = index;
      if (value == 1) {
        this.handleSelectedAdmin(this.adminData, true);
      } else {
        this.items[this.selectedIndex].value = null;
        this.items[this.selectedIndex].displayValue = "";
        this.$forceUpdate();
      }
    },
    isActive(item) {
      const isList =
        this.parentValue &&
        this.parentValue.length &&
        this.parentValue[0] &&
        this.parentValue[0].id;

      return isList
        ? this.parentValue.map((el) => el.id).includes(item.depen_on_choice_id)
        : this.parentValue == item.depen_on_choice_id;
    },
    selectBranch(value, index) {
      this.items[index].value = value;
      this.$forceUpdate();
    },
    handleAssignTo(index, value) {
      if (this.isDeleted == 1) return;
      this.selectedAdmin = value;
      this.selectedIndex = index;
      this.$refs[`${this.depth}-adminModal`].show();
    },
    handleCustomer(index, value) {
      if (this.isCustomer || this.isEdit) return;
      this.selectedIndex = index;
      this.selectedCustomer = value;
      this.$refs[`${this.depth}-customerModal`].show();
    },
    handleBooking(index, value) {
      this.selectedIndex = index;
      this.selectedBooking = value;
      this.$refs[`${this.depth}-modalBooking`].show();
    },
    handleBookingForm(id) {
      this.bookingTemplateId = id;
      this.selectedBookingId = 0;
      this.$refs[`${this.depth}-modalBooking`].hide();
      this.$refs[`${this.depth}-modalBookingForm`].show();
    },
    openBooking(booking, index) {
      this.selectedIndex = index;
      this.selectedBooking = booking;
      this.selectedBookingId = booking.ticket_relate_ref_id;
      this.$refs[`${this.depth}-modalBookingForm`].show();
    },
    handleSelectedCustomer(customer) {
      if (customer.email) this.isUserHasEmail = true;
      else if (!customer.email)
        (this.isUserHasEmail = false), (this.is_send_mail_customer = false);
      this.items[this.selectedIndex].displayValue = [
        customer.name,
        customer.telephone,
      ]
        .filter((el) => el)
        .join(", ");
      this.items[this.selectedIndex].value = customer.user_guid;
      this.selectedCustomerData = customer;
      this.$forceUpdate();
    },
    handleSelectedAdmin(admin, isAssignTome = false) {
      if (this.items[this.selectedIndex].value == admin.user_guid) {
        this.items[this.selectedIndex].displayValue = "";
        this.items[this.selectedIndex].value = "";
        this.isAssignTome = isAssignTome;
        this.$forceUpdate();
      } else {
        this.items[this.selectedIndex].displayValue = [
          admin.name,
          admin.telephone,
        ]
          .filter((el) => el)
          .join(", ");
        this.items[this.selectedIndex].value = admin.user_guid;
        this.isAssignTome = isAssignTome;
        this.$forceUpdate();
      }
    },
    handleSelectedBooking(booking) {
      const index = this.items[this.selectedIndex].value.findIndex(
        (item) => item.ticket_relate_ref_id === booking.id
      );
      if (index > -1) {
        this.items[this.selectedIndex].value.splice(index, 1);
        this.$forceUpdate();
      } else {
        this.items[this.selectedIndex].value.push({
          id: 0,
          ticket_relate_type_id: 1,
          ticket_relate_ref_id: booking.id,
          title: booking.prefix_id,
          sub_title: booking.all_service_name,
          date: booking.created_time,
          status: booking.status_name,
          status_id: booking.status,
        });
        this.$forceUpdate();
      }
    },
    onImageChange(img, index) {
      this.selectedIndex = index;
      this.items[this.selectedIndex].isLoading = true;
      var reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = async () => {
        const images = await this.saveImagetoDb(reader.result);
        this.isLoadingImage = false;
        this.isDisable = false;
        this.items[this.selectedIndex].value = images;
        this.items[this.selectedIndex].isLoading = false;
        this.$forceUpdate();
      };
    },
    saveImagetoDb: async function (img) {
      let payload = {
        Base64String: img,
        is_video: false,
        is_file: true,
        type: 1,
        file_name: new Date() + ".jpg",
      };
      const result = await this.axios.post("/ticket/UploadFile", payload);
      var data = result.data;

      if (data.result == 1) {
        return data.detail;
      }
    },
    onDeleteImage(index) {
      this.items[index].value = null;
      this.$forceUpdate();
    },
    handleOnChange(value, $event) {
      if (value.ticket_field_id == 6) {
        let index = this.items.findIndex((el) => el.ticket_field_id == 3);
        let name = value.field_choice.find((el) => el.id == $event.id);
        if (index)
          if (name) {
            let rValue = this.items[index].value
              ? this.items[index].value.trim()
              : "";
            let dName = value.field_choice.find((el) => el.name == rValue);

            if (!this.items[index].value || dName)
              this.items[index].value = name.name;
          }
      }
    },
    getTemplate() {
      this.$refs[`${this.depth}-modalTemplate`].show();
    },
    addFileAttachment(list) {
      this.fileAttach = list;
    },
    clearFileAttachment() {
      this.$refs[`${this.depth}-editor`][0].clearFileAttachment();
    },
    colorClass(item) {
      const status = parseInt(item.status_id);
      if ([3, 4].includes(status)) return "text-danger";
      else if (status == 2) return "text-success";
      else if (status == 5) return "text-info";
      else if (status == 1) return "text-warning";
      else return "text-secondary";
    },
    async getTicketConnection() {
      const res = await this.axios(`/ticket/ticketemailplugin`);
      console.log(res);
      // this.data = res.data.detail;
      this.senderList = res.data.detail;
      this.senderId = res.data.detail[0];
      // this.form.is_zort = true;
      // this.connectionModal = true;
    },
    handleOnBlur(value) {
      if (!this.senderId) this.senderId = this.senderList[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.input-action {
  position: relative;
  width: 100%;

  ::v-deep .input-custom input {
    cursor: pointer !important;
  }

  .input-action-icon {
    cursor: pointer;
    position: absolute;
    z-index: 1;
    top: 32px;
    right: 5px;
    width: 32px;
    height: 32px;
    background-color: inherit;
    color: var(--primary-color);
  }

  &.disabled {
    pointer-events: none;
  }
}

::v-deep .date-picker .vdatetime-input {
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  margin-bottom: 0;
}

.border-error {
  border-color: red !important;
  border: 1px solid red;
  border-radius: 5px;
}

::v-deep .vdatetime-popup {
  top: 60% !important;
}

.icon-primary {
  flex: 1 1 auto;
  cursor: text;
}

::v-deep .text-editor-custom {
  &.error {
    .tox-tinymce {
      border: 1px solid red;
    }
  }
}

::v-deep .multiselect {
  &.error {
    .multiselect__tags {
      border: 1px solid red;
    }
  }
  .multiselect__tags {
    height: 35px;
    min-height: unset;
    padding: 5px 40px 0 8px;
  }
  .multiselect__content-wrapper {
    min-height: unset;
  }
}

::v-deep .border-box-preview1-1 {
  max-width: 250px;
  max-height: 250px;
  width: 45%;

  .preview-box-image {
    object-fit: contain;
  }
}

.custom-label {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 5px;
}

.text-title {
  font-size: 24px;
  font-weight: bold;
}

.text-sub-title {
  font-size: 18px;
}
.pointer-event-all {
  pointer-events: all;
}

.booking-card {
  display: flex;
  gap: 16px;
  padding: 12px;
  border: 1px solid var(--theme-secondary-color);
  border-radius: 10px;
  margin-top: 12px;
  width: 100%;
  cursor: pointer;

  .prefix {
    font-weight: bold;
  }

  .detail {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .status {
      text-align: right;
    }

    .name,
    .time {
      font-size: 12px;
      color: #9b9b9b;
    }
  }

  .icon {
    background-color: var(--theme-secondary-color);
    width: 50px;
    height: 50px;
    border-radius: 10px;
    color: var(--primary-color);
    padding: 15px;
    text-align: center;
  }
}

.no-data-panel {
  display: flex;
  justify-content: center;
  padding: 25px;
  border-radius: 5px;
  background-color: whitesmoke;
  opacity: 4;
  margin-top: 16px;
  color: #beb7b7;
}
.date-picker .vdatetime-input {
  width: 100%;
  border: 1px solid #d8dbe0;
  border-radius: 5px;
  padding: 5px 10px;
  margin-bottom: 15px;
}
.date-picker .vdatetime-input {
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  margin-bottom: 0;
}
.date-picker .vdatetime-input {
  border: none !important;
}
.input-container:has(> div.vdatetime input:disabled) {
  background-color: var(--disable-color);
  /* styles to apply to the li tag */
}
.input-container {
  background-color: white;
  display: flex;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 10px;
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  align-items: center;
  justify-content: space-between;
}
</style>
